const de: Record<string, string> = {
  'nav.blog': 'Blog',
  'nav.virtualOffice': 'Virtuelles Büro',
  'nav.coworking': 'Coworking',
  'nav.accounting': 'Buchhaltung & Recht',
  'nav.contact': 'Kontakt',
  'nav.clientPortal': 'Kundenportal',
  'nav.getStarted': 'Loslegen',
  'nav.menu': 'Navigationsmenü',
  'hero.badge': 'Vertrauen von 400+ Unternehmen aus 7 Ländern',
  'hero.title1': 'Virtuelles Büro in Belgrad',
  'hero.title2': 'für ausländische und inländische Unternehmen',
  'hero.title3': '',
  'hero.desc': 'Sie gründen oder verlagern ein Unternehmen nach Serbien und sind unsicher, ob Ihre Adresse den Vorschriften entspricht und beim APR akzeptiert wird? Sie erhalten eine 100% legale Geschäftsadresse, Registrierung und Verwaltung, im Einklang mit serbischem Recht und innerhalb von 48h nach Vertragsunterzeichnung aktiv.',
  'hero.trust1': 'Geschäftsadresse in Belgrad und Kovin (Finanzamt Pančevo); Loznica kommt bald, zeigen Sie Interesse',
  'hero.trust2': 'Hilfe bei der Firmengründung in Serbien',
  'hero.trust3': 'Postempfang und -weiterleitung',
  'hero.trust4': 'Buchhaltung und administrative Unterstützung',
  'hero.cta1': 'Heute Geschäft in Serbien starten',
  'hero.cta2': 'Wie es funktioniert',
  'hero.reviews': 'aus 180+ verifizierten Kundenbewertungen',
  'hero.clientPortal': 'Kundenportal',
  'hero.active': 'Aktiv',
  'hero.documents': 'Dokumente',
  'hero.invoices': 'Rechnungen',
  'hero.plan': 'Tarif',
  'hero.address': 'Adresse',
  'hero.liveActivity': 'Live-Aktivität',
  'hero.docUploaded': 'Neues Dokument hochgeladen',
  'hero.invoicePaid': 'Rechnung bezahlt',
  'hero.mailForwarded': 'Post weitergeleitet',
  'hero.newClients': '12 neue Kunden',
  'hero.thisMonth': 'Diesen Monat',
  'hero.mockCompany': 'EVI Solutions DOO',
  'hero.activityCompany1': 'Tehno sistem d.o.o.',
  'hero.activityCompany2': 'Jadran trade d.o.o.',
  'hero.activityCompany3': 'Stojanović consulting d.o.o.',
  'hero.timeAgo2m': 'vor 2 Min.',
  'hero.timeAgo18m': 'vor 18 Min.',
  'hero.timeAgo1h': 'vor 1 Std.',
  'hero.kpi.documentsSub': '2 neu diese Woche',
  'hero.kpi.invoicesSub': '1 Zahlung ausstehend',
  'hero.kpi.planSub': 'Virtuelles Büro',
  'hero.kpi.addressValue': 'Belgrad',
  'hero.kpi.addressSub': 'Topčiderska 14',
  'services.tag': 'Was wir anbieten',
  'services.title': 'Geschäftsadresse, Postannahme und\nBuchhaltung an einem Ort',
  'services.desc':
    'Für ausländische Unternehmen und lokale Unternehmer: Top14 Bürolösungen decken Registrierung, Adresse und laufende Betreuung ab.',
  'services.mostPopular': 'Am beliebtesten',
  'services.virtualOffice.tag': 'Geschäftsadresse & Registrierung',
  'services.virtualOffice.title': 'Virtuelles Büro',
  'services.virtualOffice.desc':
    'Registrierte Geschäftsadressen in Belgrad (Topčiderska) und Kovin (Finanzamt Pančevo). Standort Loznica folgt bald, kontaktieren Sie uns bei Interesse. Inklusive Postbearbeitung, Unternehmensregistrierungsunterstützung und sicherem Dokumentenportal.',
  'services.virtualOffice.taxNote':
    'Alternative Standorte können je nach Geschäftsmodell eine stärkere steuerliche Optimierung ermöglichen.',
  'services.virtualOffice.f1': 'Belgrad – Topčiderska, Gemeinde Savski venac',
  'services.virtualOffice.f5': 'Kovin, Finanzamt Pančevo - günstigste Pauschalbesteuerung in Serbien',
  'services.virtualOffice.f6': 'Loznica, demnächst, nahe BiH-Grenze (Interesse bekunden)',
  'services.virtualOffice.f2': 'APR-Registrierungsunterstützung',
  'services.virtualOffice.f3': 'Geeignet für ausländische Unternehmen',
  'services.virtualOffice.f4': 'Dokumentenverwaltungsportal',
  'services.virtualOffice.price': '3.500 RSD',
  'services.virtualOffice.per': '/ Monat (~30 EUR)',
  'services.virtualOffice.learn': 'Mehr erfahren',
  'services.coworking.tag': 'Flexibler Arbeitsraum',
  'services.coworking.title': 'Coworking-Space',
  'services.coworking.desc': 'Moderne Arbeitsplätze und Privatbüros im Zentrum von Belgrad. Gigabit-Internet mit 1 Gbps, 3 Besprechungsräume und ein ruhiger Raum für maximal 20 Nutzer.',
  'services.coworking.price': '€89',
  'services.coworking.per': '/ Monat',
  'services.coworking.plans': 'Tarife ansehen',
  'services.accounting.tag': 'Geschäftsunterstützung',
  'services.accounting.title': 'Buchhaltung & Recht',
  'services.accounting.desc': 'Buchhaltung, MwSt-Registrierung, Steuererklärungen und Rechtsberatung.',
  'services.accounting.cta': 'Kostenlose Beratung',
  'capitaale.aria': 'Empfohlene App für Pauschalunternehmer',
  'capitaale.tag': 'Empfohlen für Pauschalunternehmer',
  'capitaale.desc':
    'Capitaale ist eine App für Unternehmer, die im Ausland abrechnen. Echter RSD-Saldo nach Bankkurs, Live-Pauschallimit, Warnung wenn ein Kunde über 70 % des Umsatzes ausmacht, und Rechnung in EUR oder USD in 60 Sekunden. Die ersten 7 Tage kostenlos.',
  'capitaale.cta': '7 Tage kostenlos testen',
  'capitaale.external': 'Öffnet die Capitaale-Partnerseite',
  'how.tag': 'Schritt für Schritt',
  'how.title': 'So starten Sie mit uns Ihr Geschäft in Serbien',
  'how.desc':
    'Wir begleiten Sie vom ersten Gedanken bis zum voll operativen Unternehmen – ohne Komplikationen und Zeitverlust.',
  'how.step1.title': 'Kurzes Beratungsgespräch',
  'how.step1.lead': 'Wir verstehen Ihre Bedürfnisse und empfehlen die beste Lösung',
  'how.step1.desc':
    'Wir sprechen über Ihr Geschäft, Ihre Ziele und Ihr Tätigkeitsspektrum in Serbien und schlagen darauf basierend das passende Leistungspaket vor.',
  'how.step1.badge': '15–30 Min.',
  'how.step2.title': 'Angebot & Vertrag',
  'how.step2.lead': 'Sie erhalten einen klaren Plan und alle Konditionen im Voraus',
  'how.step2.desc':
    'Wir senden Ihnen ein konkretes Leistungsangebot und ein Mustervertrag. Alles ist transparent, ohne versteckte Kosten.',
  'how.step2.check1': 'klar definiert',
  'how.step2.check2': 'wenig Bürokratie',
  'how.step3.title': 'Zustimmung zur Geschäftsadresse',
  'how.step3.lead': 'Sie erhalten die Erlaubnis, unsere Adresse als Firmensitz zu nutzen',
  'how.step3.intro': 'Von uns erhalten Sie:',
  'how.step3.bullet1': 'Zustimmung zur Anmeldung unserer Adresse beim APR',
  'how.step3.bullet2': 'die für den Firmensitz erforderlichen Unterlagen',
  'how.step3.bullet3': 'Postannahme an dieser Adresse',
  'how.step3.badge': 'in der Regel wenige Tage',
  'how.step4.title': 'Aktivierung & Arbeit im Portal',
  'how.step4.lead': 'Alles Weitere erledigen Sie an einem Ort',
  'how.step4.desc': 'Nach Vertragsunterzeichnung richten wir Ihr Konto in unserem Portal ein, wo Sie:',
  'how.step4.bullet1': 'Dokumente verwalten',
  'how.step4.bullet2': 'mit dem Team kommunizieren',
  'how.step4.bullet3': 'Rechnungen und Leistungen verfolgen',
  'how.step4.badge': 'Support 24/7',
  'how.cta': 'Starten Sie ohne Komplikationen',
  'how.learnMore': 'Mehr erfahren',
  'vo.tag': 'Virtuelles Büro',
  'vo.title': 'Professionelle Belgrader\nAdresse für Ihr Unternehmen',
  'vo.desc': 'Registrierte Adresse in der Topčiderska Straße, Belgrad - ideal für ausländische Unternehmen.',
  'vo.standard': 'Standard',
  'vo.premium': 'Premium',
  'vo.popular': 'Am beliebtesten',
  'vo.month': '/ Monat',
  'vo.getStarted': 'Loslegen',
  'vo.contact': 'Kontakt',
  'vo.included': 'In allen Tarifen enthalten',
  'cw.tag': 'Coworking-Space',
  'cw.title': 'Moderne Arbeitsräume\nim Zentrum von Belgrad',
  'cw.desc': 'Flexible Coworking-Spaces für produktives Arbeiten.',
  'cw.hotDesk': 'Hot Desk',
  'cw.dedicatedDesk': 'Fester Schreibtisch',
  'cw.privateOffice': 'Privatbüro',
  'cw.month': '/ Monat',
  'cw.getStarted': 'Loslegen',
  'cw.bookTour': 'Tour buchen',
  'acc.tag': 'Buchhaltung & Recht',
  'acc.title': 'Vollständige finanzielle und rechtliche\nUnterstützung für Ihr Unternehmen',
  'acc.desc': 'Unser Team erfahrener Buchhalter und Rechtsberater.',
  'acc.basic': 'Basis',
  'acc.professional': 'Professionell',
  'acc.enterprise': 'Enterprise',
  'acc.month': '/ Monat',
  'acc.getStarted': 'Loslegen',
  'acc.consultation': 'Kostenlose Beratung',
  'acc.pricing.title': 'Preisliste Buchhaltungsdienstleistungen',
  'acc.pricing.subtitle': 'Alle Preise in serbischen Dinar (RSD). Preise sind Mindestpreise und verhandelbar.',
  'acc.pricing.service': 'Dienstleistung',
  'acc.pricing.clientPrice': 'Kundenpreis',
  'acc.pricing.regularPrice': 'Regulärer Preis',
  'acc.pricing.unit': 'Einheit / Hinweis',
  'acc.pricing.online': 'Online',
  'trust.tag': 'Warum Top14',
  'trust.title': 'Vertrauen von Unternehmen\naus aller Welt',
  'trust.desc':
    'Mehr als 400 Unternehmen aus 7 Ländern wählen Top14 Bürolösungen für ihre Geschäftspräsenz in Serbien.',
  'trust.companies': 'Aktive Unternehmen',
  'trust.countries': 'Länder',
  'trust.years': 'Jahre Erfahrung',
  'trust.satisfaction': 'Kundenzufriedenheit',
  'contact.tag': 'Kontakt aufnehmen',
  'contact.title': 'Top14 Bürolösungen',
  'contact.desc': 'Bereit, Ihre serbische Geschäftspräsenz aufzubauen? Schreiben Sie uns.',
  'contact.address': 'Adresse',
  'contact.phone': 'Telefon',
  'contact.email': 'E-Mail',
  'contact.hours': 'Geschäftszeiten',
  'contact.hoursValue': 'Mo–Fr, 09:00–17:00 Uhr MEZ',
  'contact.addressValue': 'Topčiderska 14, 11000 Belgrad, Serbien',
  'contact.phoneValue': '+381 62 262 221',
  'contact.emailValue': 'office@top14.rs',
  'contact.mapStreet': 'Topčiderska',
  'contact.mapCity': 'Belgrad, Serbien',
  'contact.responseTime': 'Typische Antwortzeit',
  'contact.responseValue': 'Unter 4 Stunden während der Geschäftszeiten',
  'contact.weRespond': 'Wir antworten auf',
  'contact.formTitle': 'Nachricht senden',
  'contact.formDesc': 'Wir antworten innerhalb eines Werktages.',
  'contact.name': 'Vollständiger Name *',
  'contact.emailField': 'E-Mail-Adresse *',
  'contact.phoneField': 'Telefonnummer für Rückfragen *',
  'contact.placeholderPhone': '+381 60 123 4567',
  'contact.errPhone': 'Bitte geben Sie Ihre Telefonnummer ein.',
  'contact.company': 'Unternehmensname',
  'contact.country': 'Land',
  'contact.officeLocation': 'Standort des virtuellen Büros *',
  'contact.selectOfficeLocation': 'Standort wählen…',
  'contact.location.belgrade': 'Belgrad, Topčiderska - Finanzamt Savski venac',
  'contact.location.kovinPancevo': 'Kovin - Finanzamt Pančevo (günstigste Pauschalbesteuerung in Serbien)',
  'contact.location.loznica': 'Loznica, demnächst (nah BiH); Interesse bekunden',
  'contact.location.arandjelovac': 'Aranđelovac',
  'contact.errOfficeLocation': 'Bitte wählen Sie einen Bürostandort.',
  'contact.service': 'Interessierende Dienstleistungen *',
  'contact.selectService': 'Dienstleistung auswählen...',
  'contact.placeholderName': 'Max Mustermann',
  'contact.placeholderEmail': 'max@beispiel.de',
  'contact.placeholderCompany': 'Muster GmbH',
  'contact.placeholderCountry': 'Deutschland',
  'contact.placeholderMessage':
    'Wir suchen ein virtuelles Büro in Belgrad und Unterstützung bei der Niederlassungsgründung. Bitte skizzieren Sie die Schritte und ungefähren Kosten.',
  'contact.serviceRequired': 'Bitte wählen Sie mindestens eine Dienstleistung.',
  'contact.errName': 'Bitte geben Sie Ihren Namen ein.',
  'contact.errEmail': 'Bitte geben Sie Ihre E-Mail ein.',
  'contact.errEmailInvalid': 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
  'contact.errMessage': 'Bitte geben Sie eine Nachricht ein.',
  'contact.errMessageMin': 'Die Nachricht muss mindestens 20 Zeichen lang sein.',
  'contact.message': 'Nachricht *',
  'contact.messageHint': 'Beschreiben Sie Ihre Geschäftsanforderungen.',
  'contact.send': 'Nachricht senden',
  'contact.sending': 'Senden...',
  'contact.successTitle': 'Nachricht gesendet',
  'contact.successDesc': 'Vielen Dank. Unser Team wird sich innerhalb eines Werktages melden.',
  'contact.sendAnother': 'Weitere Nachricht senden',
  'contact.services.vo': 'Virtuelles Büro',
  'contact.services.cw': 'Coworking-Space',
  'contact.services.acc': 'Buchhaltung & Rechtsunterstützung',
  'contact.services.reg': 'Unternehmensregistrierung',
  'contact.services.gen': 'Allgemeine Anfrage',
  'contact.toast': 'Nachricht gesendet! Wir melden uns innerhalb eines Werktages.',
  'contact.errorSend': 'Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es gleich erneut.',
  'footer.desc':
    'Top14 - professionelle virtuelle Büro-, Coworking- und Geschäftsunterstützung für Unternehmen in Serbien.',
  'footer.services': 'Dienstleistungen',
  'footer.company': 'Unternehmen',
  'footer.contact': 'Kontakt',
  'footer.about': 'Über uns',
  'footer.howItWorks': 'Wie es funktioniert',
  'footer.pricing': 'Preise',
  'footer.clientPortal': 'Kundenportal',
  'footer.privacy': 'Datenschutzrichtlinie',
  'footer.terms': 'Nutzungsbedingungen',
  'footer.cookies': 'Cookie-Richtlinie',
  'legal.backHome': 'Zur Startseite',
  'footer.rights': '© 2026 EVI Solutions DOO. Alle Rechte vorbehalten.',
  'portal.adminDashboard': 'Admin-Dashboard',
  'portal.operatorDashboard': 'Operator-Dashboard',
  'portal.roleBadgeAdmin': 'Administrator',
  'portal.roleBadgeOperator': 'Operator',
  'portal.roleBadgeClient': 'Kunde',
  'portal.clientDashboard': 'Kunden-Dashboard',
  'portal.signOut': 'Abmelden',
  'portal.publicSite': 'Öffentliche Website',
  'portal.settings': 'Einstellungen',
  'portal.password.title': 'Passwort ändern',
  'portal.password.hint': 'Für Konten mit E-Mail und Passwort.',
  'portal.password.current': 'Aktuelles Passwort',
  'portal.password.new': 'Neues Passwort',
  'portal.password.confirm': 'Neues Passwort bestätigen',
  'portal.password.submit': 'Passwort aktualisieren',
  'portal.password.saving': 'Wird gespeichert…',
  'portal.password.changed': 'Passwort wurde aktualisiert.',
  'portal.password.wrongCurrent': 'Aktuelles Passwort ist falsch.',
  'portal.password.mismatch': 'Die Passwörter stimmen nicht überein.',
  'portal.password.tooShort': 'Mindestens 8 Zeichen.',
  'portal.password.changeFailed': 'Passwort konnte nicht geändert werden.',
  'portal.password.noEmail': 'Keine E-Mail-Adresse.',
  'portal.darkMode': 'Dunkelmodus',
  'portal.notifications': 'Benachrichtigungen',
  'portal.markAllRead': 'Alle als gelesen markieren',
  'portal.viewAll': 'Alle anzeigen',
  'portal.notificationsPageTitle': 'Benachrichtigungen',
  'portal.notificationsUnreadHint': 'ungelesen',
  'portal.notificationsAllCaughtUp': 'Alles gelesen',
  'portal.notificationsEmpty': 'Keine Benachrichtigungen.',
  'portal.notificationsLoadError': 'Benachrichtigungen konnten nicht geladen werden.',
  'portal.markAllReadDone': 'Alles als gelesen markiert.',
  'portal.notificationsNeedCompany': 'Benachrichtigungen erscheinen, sobald Ihr Unternehmen geladen ist.',
  'portal.notif.contactForm': 'Neue Kontaktanfrage: {{name}}',
  'portal.notif.newTask': 'Neue Aufgabenanfrage',
  'portal.profile': 'Profil',
  'portal.search': 'Unternehmen, Dokumente suchen...',
  'portal.company': 'Unternehmen',
  'portal.contactSupport': 'Support kontaktieren',
  'portal.exportReport': 'Bericht exportieren',
  'portal.addCompany': 'Unternehmen hinzufügen',
  'portal.language': 'Sprache',
  'portal.openMenu': 'Menü öffnen',
  'sidebar.main': 'Navigation',
  'sidebar.dashboard': 'Übersicht',
  'sidebar.myCompany': 'Mein Unternehmen',
  'sidebar.companies': 'Unternehmen',
  'sidebar.documents': 'Dokumente',
  'sidebar.invoices': 'Rechnungen',
  'sidebar.users': 'Benutzer',
  'sidebar.calls': 'Eingegangene Anrufe',
  'sidebar.callsAdmin': 'Anrufe',
  'sidebar.contacts': 'Kontaktformular',
  'sidebar.notifications': 'Benachrichtigungen',
  'sidebar.tasks': 'Aufgaben',
  'sidebar.taskRequests': 'Anfragen',
  'admin.tab.dashboard': 'Übersicht',
  'admin.tab.companies': 'Unternehmen',
  'admin.tab.documents': 'Dokumente',
  'admin.tab.invoices': 'Rechnungen',
  'admin.tab.users': 'Benutzer',
  'admin.tab.tasks': 'Aufgaben',
  'admin.tab.calls': 'Anrufe',
  'admin.tab.contacts': 'Kontaktformular',
  'admin.contacts.title': 'Anfragen aus dem Kontaktformular',
  'admin.contacts.subtitle': 'Anfragen',
  'admin.contacts.newBadge': 'neu',
  'admin.contacts.unreadBadge': 'ungelesen',
  'admin.contacts.refresh': 'Aktualisieren',
  'admin.contacts.loading': 'Wird geladen…',
  'admin.contacts.empty': 'Keine Anfragen.',
  'admin.contacts.loadError': 'Anfragen konnten nicht geladen werden.',
  'admin.contacts.updateError': 'Speichern fehlgeschlagen.',
  'admin.contacts.statusSaved': 'Status gespeichert.',
  'admin.contacts.noteSaved': 'Notiz gespeichert.',
  'admin.contacts.col.date': 'Datum',
  'admin.contacts.col.contact': 'Kontakt',
  'admin.contacts.col.office': 'Büro',
  'admin.contacts.col.services': 'Leistungen',
  'admin.contacts.col.status': 'Status',
  'admin.contacts.col.notes': 'Interne Notiz',
  'admin.contacts.affiliate': 'Affiliate',
  'admin.contacts.notePlaceholder': 'Vereinbarung, nächster Schritt…',
  'admin.contacts.saveNote': 'Notiz speichern',
  'admin.contacts.openMessage': 'Nachricht',
  'admin.contacts.close': 'Schließen',
  'admin.contacts.status.new': 'Neu',
  'admin.contacts.status.contacted': 'Kontaktiert',
  'admin.contacts.status.no_show_negotiations': 'Nicht in Verhandlungen gemeldet',
  'admin.contacts.status.in_discussion': 'In Verhandlung',
  'admin.contacts.status.became_client': 'Kunde geworden',
  'admin.contacts.status.declined': 'Abgelehnt',
  'admin.contacts.status.spam': 'Spam',
  'admin.cancel': 'Abbrechen',
  'admin.filters.title': 'Filter',
  'admin.filters.company': 'Unternehmen',
  'admin.filters.allCompanies': 'Alle Unternehmen',
  'admin.filters.category': 'Dokumenttyp',
  'admin.filters.allCategories': 'Alle Typen',
  'admin.filters.status': 'Status',
  'admin.filters.allStatuses': 'Alle Status',
  'admin.filters.dateFrom': 'Von',
  'admin.filters.dateTo': 'Bis',
  'admin.filters.priority': 'Priorität',
  'admin.filters.allPriorities': 'Alle',
  'admin.filters.reset': 'Zurücksetzen',
  'admin.users.title': 'Benutzerverwaltung',
  'admin.users.total': 'Benutzer',
  'admin.users.addUser': 'Benutzer hinzufügen',
  'admin.users.newUser': 'Neuer Benutzer',
  'admin.users.fullName': 'Vollständiger Name',
  'admin.users.email': 'E-Mail',
  'admin.users.password': 'Passwort',
  'admin.users.roleClient': 'Kunde',
  'admin.users.roleOperator': 'Operator',
  'admin.users.roleAdmin': 'Administrator',
  'admin.users.operatorCannotEditAdmin': 'Operatoren können keine Administratorkonten bearbeiten.',
  'admin.users.operatorCannotAssignAdmin': 'Operatoren können die Rolle Administrator nicht vergeben.',
  'admin.users.noCompany': 'Kein Unternehmen zugewiesen',
  'admin.users.create': 'Benutzer erstellen',
  'admin.users.creating': 'Erstellen...',
  'admin.users.created': 'Benutzer erstellt',
  'admin.users.createFailed': 'Fehler beim Erstellen des Benutzers',
  'admin.users.fillRequired': 'Bitte alle Pflichtfelder ausfüllen',
  'admin.users.passwordMin': 'Passwort muss mindestens 8 Zeichen haben',
  'admin.users.loading': 'Benutzer werden geladen...',
  'admin.users.noUsers': 'Keine Benutzer gefunden',
  'admin.users.name': 'Name',
  'admin.users.emailCol': 'E-Mail',
  'admin.users.roleCol': 'Rolle',
  'admin.users.companyCol': 'Unternehmen',
  'admin.users.assignCompany': 'Unternehmen zuweisen',
  'admin.users.none': 'Keines',
  'admin.users.assigned': 'Unternehmen zugewiesen',
  'admin.users.assignFailed': 'Fehler beim Zuweisen des Unternehmens',
  'admin.users.actions': 'Aktionen',
  'admin.users.edit': 'Bearbeiten',
  'admin.users.resetPassword': 'Passwort zurücksetzen',
  'admin.users.editUser': 'Benutzer bearbeiten',
  'admin.users.saveChanges': 'Speichern',
  'admin.users.updated': 'Benutzer aktualisiert',
  'admin.users.updateFailed': 'Aktualisierung fehlgeschlagen',
  'admin.users.activeUser': 'Konto aktiv',
  'admin.users.resetPasswordTitle': 'Neues Passwort setzen',
  'admin.users.newPassword': 'Neues Passwort',
  'admin.users.confirmPassword': 'Passwort bestätigen',
  'admin.users.passwordMismatch': 'Passwörter stimmen nicht überein',
  'admin.users.passwordChanged': 'Passwort wurde zurückgesetzt',
  'admin.users.passwordChangeFailed': 'Passwort konnte nicht zurückgesetzt werden',
  'admin.users.serverConfig':
    'SUPABASE_SERVICE_ROLE_KEY auf dem Server setzen, um Passwort-Reset im Panel zu ermöglichen.',
  'admin.calls.title': 'Anrufe',
  'admin.calls.recent': 'letzte protokollierte Anrufe',
  'admin.calls.addCall': 'Anruf erfassen',
  'admin.calls.newCall': 'Neuer Anruf',
  'admin.calls.selectCompany': 'Unternehmen *',
  'admin.calls.caller': 'Anrufer',
  'admin.calls.callerPhone': 'Rufnummer',
  'admin.calls.reason': 'Grund des Anrufs',
  'admin.calls.priority.low': 'Niedrig',
  'admin.calls.priority.medium': 'Mittel',
  'admin.calls.priority.high': 'Hoch',
  'admin.calls.duration': 'Dauer (Min., optional)',
  'admin.calls.notes': 'Notizen',
  'admin.calls.handledBy': 'Bearbeitet von',
  'admin.calls.recording': 'Aufzeichnung (optional)',
  'admin.calls.recordingHint': 'Audio anhängen (MP3, WAV, M4A …)',
  'admin.calls.save': 'Anruf speichern',
  'admin.calls.saving': 'Speichern…',
  'admin.calls.saved': 'Anruf gespeichert',
  'admin.calls.saveFailed': 'Anruf konnte nicht gespeichert werden',
  'admin.calls.fillRequired': 'Unternehmen, Anrufer, Nummer und Grund sind erforderlich',
  'admin.calls.loading': 'Laden…',
  'admin.calls.noCalls': 'Noch keine Anrufe',
  'admin.calls.deleted': 'Anruf gelöscht',
  'admin.calls.deleteFailed': 'Anruf konnte nicht gelöscht werden',
  'admin.calls.openRecording': 'Aufzeichnung abspielen',
  'admin.calls.storageFailed': 'Upload der Aufzeichnung fehlgeschlagen',
  'admin.calls.delete': 'Anruf löschen',
  'admin.docs.title': 'Dokumentenverwaltung',
  'admin.docs.recent': 'aktuelle Dokumente',
  'admin.docs.addDoc': 'Dokument hinzufügen',
  'admin.docs.newDoc': 'Neues Dokument',
  'admin.docs.selectCompany': 'Unternehmen auswählen *',
  'admin.docs.docName': 'Dokumentname',
  'admin.docs.description': 'Dokumentbeschreibung',
  'admin.docs.uploadPdf': 'PDF-Datei hochladen',
  'admin.docs.category': 'Kategorie',
  'admin.docs.fileUrl': 'Datei-URL (optional)',
  'admin.docs.fileSize': 'Dateigröße (z.B. 284 KB)',
  'admin.docs.save': 'Dokument speichern',
  'admin.docs.saving': 'Speichern...',
  'admin.docs.uploaded': 'Dokument hinzugefügt',
  'admin.docs.uploadFailed': 'Fehler beim Hinzufügen des Dokuments',
  'admin.docs.fillRequired': 'Unternehmen und Dokumentname sind erforderlich',
  'admin.docs.operatorNoInvoiceCategory': 'Operatoren können keine Dokumente in der Kategorie Rechnungen hochladen.',
  'admin.docs.loading': 'Dokumente werden geladen...',
  'admin.docs.noDocs': 'Noch keine Dokumente',
  'admin.docs.deleted': 'Dokument gelöscht',
  'admin.docs.deleteFailed': 'Fehler beim Löschen des Dokuments',
  'admin.docs.storageUploadFailed': 'Upload in den Speicher ist fehlgeschlagen',
  'admin.docs.open': 'Öffnen',
  'admin.docs.noFile': 'Für diesen Eintrag ist keine Datei gespeichert.',
  'admin.docs.openFailed': 'Datei konnte nicht geöffnet werden.',
  'admin.docs.deleteFileFailed': 'Datei konnte nicht aus dem Speicher gelöscht werden',
  'admin.docs.cat.company': 'Unternehmensdokumente',
  'admin.docs.cat.archive': 'Archivbuch',
  'admin.docs.cat.mail': 'Eingehende Post',
  'admin.docs.cat.tax': 'Steuerpostfach',
  'admin.docs.cat.registration': 'Registrierung',
  'admin.docs.cat.lease': 'Mietvertrag',
  'admin.docs.cat.accounting': 'Buchhaltung',
  'admin.docs.cat.other': 'Sonstiges',

  'docCat.CompanyLegal': 'Handels- & Registerunterlagen (APR, Satzung, Beschlüsse)',
  'docCat.StatutoryArchive': 'Pflichtarchiv & Aufbewahrung',
  'docCat.MailForwarding': 'Post & Weiterleitung (Scans, Eingang)',
  'docCat.TaxCompliance': 'Steuern, Abgaben & Meldungen',
  'docCat.ContractsLeases': 'Verträge & Mietverhältnisse',
  'docCat.VirtualOfficeServices': 'Virtual-Office-Leistungen',
  'docCat.Accounting': 'Buchhaltung & Jahresabschluss',
  'docCat.Invoices': 'Rechnungen',
  'docCat.Other': 'Sonstiges',
  'admin.invoices.title': 'Rechnungsverwaltung',
  'admin.invoices.recent': 'aktuelle Rechnungen',
  'admin.invoices.issue': 'Rechnung ausstellen',
  'admin.invoices.newInvoice': 'Neue Rechnung',
  'admin.invoices.selectCompany': 'Unternehmen auswählen *',
  'admin.invoices.description': 'Beschreibung',
  'admin.invoices.amount': 'Betrag',
  'admin.invoices.dueDate': 'Fälligkeitsdatum',
  'admin.invoices.create': 'Rechnung erstellen',
  'admin.invoices.creating': 'Erstellen...',
  'admin.invoices.created': 'Rechnung erstellt',
  'admin.invoices.createFailed': 'Fehler beim Erstellen der Rechnung',
  'admin.invoices.fillRequired': 'Bitte alle Pflichtfelder ausfüllen',
  'admin.invoices.loading': 'Rechnungen werden geladen...',
  'admin.invoices.noInvoices': 'Noch keine Rechnungen',
  'admin.invoices.number': 'Rechnungsnr.',
  'admin.invoices.companyCol': 'Unternehmen',
  'admin.invoices.descCol': 'Beschreibung',
  'admin.invoices.amountCol': 'Betrag',
  'admin.invoices.statusCol': 'Status',
  'admin.invoices.markedPaid': 'Als bezahlt markiert',
  'admin.invoices.updateFailed': 'Fehler beim Aktualisieren der Rechnung',
  'admin.invoices.deleted': 'Rechnung gelöscht',
  'admin.invoices.deleteFailed': 'Fehler beim Löschen der Rechnung',
  'admin.invoices.invoiceNumberLabel': 'Rechnungsnummer (manuell)',
  'admin.invoices.issueDate': 'Ausstellungsdatum',
  'admin.invoices.attachmentLabel': 'Rechnungsanhang (PDF oder Bild)',
  'admin.invoices.attachmentHint': 'Kunden sehen die Datei im Portal unter Dokumenten.',
  'admin.invoices.chooseFile': 'Datei wählen',
  'admin.invoices.uploadingDoc': 'Anhang wird hochgeladen...',
  'admin.invoices.duplicateNumber': 'Diese Rechnungsnummer existiert bereits.',
  'admin.invoices.documentUploadFailed': 'Rechnung erstellt, aber Upload des Anhangs fehlgeschlagen',
  'admin.invoices.statusUpdated': 'Rechnungsstatus aktualisiert',
  'admin.invoices.changeStatus': 'Status ändern',
  'admin.invoices.deleteInvoice': 'Rechnung löschen',
  'admin.invoices.editInvoice': 'Rechnung bearbeiten',
  'admin.invoices.saveChanges': 'Änderungen speichern',
  'admin.invoices.saving': 'Speichern...',
  'admin.invoices.updated': 'Rechnung aktualisiert',
  'admin.invoices.stPending': 'Ausstehend',
  'admin.invoices.stPaid': 'Bezahlt',
  'admin.invoices.stOverdue': 'Überfällig',
  'admin.invoices.stCancelled': 'Storniert',
  'admin.companies.businessAddress': 'Geschäftsadresse',
  'admin.companies.taxAddress': 'Steueradresse / Separate Geschäftseinheit',
  'admin.companies.accountManager': 'Kundenbetreuer',
  'admin.companies.accountManagerEmail': 'Betreuer-E-Mail',
  'admin.companies.accountManagerPhone': 'Betreuer-Telefon',
  'admin.companies.phone': 'Unternehmenstelefon',
  'admin.companies.email': 'Unternehmens-E-Mail',
  'admin.companies.regNumber': 'Registrierungsnummer',
  'admin.companies.notes': 'Notizen',
  'admin.companies.sectionCompany': 'Unternehmen',
  'admin.companies.sectionManager': 'Kundenbetreuer',
  'admin.companies.companyName': 'Firmenname',
  'admin.companies.country': 'Land',
  'admin.companies.registrationAddress': 'Adresse und Ort der Registrierung',
  'admin.companies.aprEmail': 'Offizielle E-Mail für APR',
  'admin.companies.aprPhone': 'Offizielles Telefon für APR',
  'admin.companies.ownerPhone': 'Direktnummer des Inhabers',
  'admin.companies.ownerEmail': 'Direkte E-Mail des Inhabers',
  'admin.companies.pib': 'Steuernummer (PIB)',
  'admin.companies.companyRegistrationDate': 'Datum der Firmenregistrierung',
  'admin.companies.portalRegistrationDate': 'Registrierungsdatum im Portal',
  'admin.companies.managerName': 'Name des Betreuers',
  'admin.companies.managerEmail': 'E-Mail des Betreuers',
  'admin.companies.managerContactPhone': 'Kontakttelefon',
  'admin.tasks.title': 'Anfragen',
  'admin.tasks.noTasks': 'Keine Anfragen',
  'admin.tasks.pending': 'Ausstehend',
  'admin.tasks.submitted': 'Eingereicht',
  'admin.tasks.ticketUrlPlaceholder': 'https://... Link zum Buchhalter-Ticket',
  'admin.tasks.saveUrl': 'Link speichern',
  'admin.tasks.openTicket': 'Ticket öffnen',
  'admin.tasks.urlSaved': 'Link gespeichert.',
  'admin.tasks.urlSaveFailed': 'Link konnte nicht gespeichert werden.',
  'admin.tasks.targetAccountant': 'Buchhaltung',
  'admin.tasks.targetSupport': 'Support',
  'admin.tasks.urgency': 'Dringlichkeit',
  'admin.tasks.contactPref': 'Kontakt',
  'admin.tasks.tabAccountant': 'Buchhaltung',
  'admin.tasks.tabSupport': 'Support',
  'admin.tasks.emptyAccountant': 'Noch keine Buchhaltungsanfragen.',
  'admin.tasks.emptySupport': 'Noch keine Support-Anfragen.',
  'admin.tasks.supportStatusReceived': 'Eingegangen',
  'admin.tasks.supportStatusInProgress': 'In Bearbeitung',
  'admin.tasks.supportStatusCompleted': 'Erledigt',
  'admin.tasks.supportStatusLabel': 'Status',
  'admin.tasks.supportStatusSaved': 'Status gespeichert.',
  'admin.tasks.supportStatusSaveFailed': 'Status konnte nicht gespeichert werden.',
  'client.docs.title': 'Unternehmensdokumente',
  'client.docs.statsLine': '{{count}} Dokumente · {{new}} neu',
  'client.docs.search': 'Dokumente suchen...',
  'client.docs.all': 'Alle Kategorien',
  'client.docs.dateFrom': 'Von Datum',
  'client.docs.dateTo': 'Bis Datum',
  'client.docs.clearDates': 'Daten löschen',
  'client.docs.noResults': 'Keine Dokumente gefunden',
  'client.docs.adjustSearch': 'Suche oder Filter anpassen',
  'client.docs.download': 'Herunterladen',
  'client.docs.preview': 'Vorschau',
  'client.docs.noFile': 'Datei nicht verfügbar.',
  'client.docs.openFailed': 'Datei konnte nicht geöffnet werden.',
  'client.docs.invoiceBadge': 'Rechnung',
  'client.docs.loading': 'Dokumente werden geladen...',
  'client.docs.loadFailed': 'Dokumente konnten nicht geladen werden.',
  'client.docs.uploadTitle': 'Dokument hochladen',
  'client.docs.uploadHint': 'Laden Sie eine datei zu Ihrem Unternehmen hoch. PDF, Bilder und gängige Office-Formate werden unterstützt.',
  'client.docs.docNamePlaceholder': 'Dokumentname (optional)',
  'client.docs.chooseFile': 'Datei wählen',
  'client.docs.uploading': 'Wird hochgeladen...',
  'client.docs.submitUpload': 'Dokument senden',
  'client.docs.uploaded': 'Dokument hochgeladen',
  'client.docs.uploadFailed': 'Upload fehlgeschlagen',
  'client.docs.fillRequired': 'Bitte wählen Sie eine Datei.',
  'client.invoices.title': 'Rechnungen & Zahlungen',
  'client.company.address': 'Geschäftsadresse',
  'client.company.taxAddress': 'Steueradresse / Sep. Einheit',
  'client.company.fieldNotSet': 'Nicht angegeben',
  'client.company.country': 'Land',
  'client.company.registrationAddress': 'Adresse und Ort der Registrierung',
  'client.company.companyEmail': 'Unternehmens-E-Mail',
  'client.company.aprEmail': 'Offizielle APR-E-Mail',
  'client.company.aprPhone': 'Offizielles APR-Telefon',
  'client.company.ownerPhone': 'Telefon des Inhabers',
  'client.company.ownerEmail': 'E-Mail des Inhabers',
  'client.company.pib': 'Steuernummer (PIB)',
  'client.company.notesCompany': 'Notizen',
  'client.company.companyRegDate': 'Datum der Firmenregistrierung',
  'client.company.portalRegDate': 'Registrierungsdatum im Portal',
  'client.company.start': 'Servicebeginn',
  'client.company.renewal': 'Nächste Verlängerung',
  'client.company.plan': 'Tarif',
  'client.company.manager': 'Ihr Kundenbetreuer',
  'client.company.noCompany': 'Kein Unternehmen zugewiesen.',
  'client.company.contactManager': 'Kontaktieren Sie Ihren Kundenbetreuer.',
  'company.plan.group.vo': 'Virtuelles Büro',
  'company.plan.group.cw': 'Coworking',
  'company.plan.vo_starter': 'Starter',
  'company.plan.vo_business': 'Business',
  'company.plan.vo_premium': 'Premium',
  'company.plan.cw_hot_desk': 'Hot Desk',
  'company.plan.cw_fixed_desk': 'Fester Schreibtisch',
  'company.plan.cw_private_office': 'Privatbüro',
  'client.kpi.docs': 'Dokumente gesamt',
  'client.kpi.invoices': 'Aktive Rechnungen',
  'client.kpi.overdue': 'Überfällige Rechnungen',
  'client.kpi.renewal': 'Nächste Verlängerung',
  'client.kpi.docsSub': '{{count}} neu diesen Monat',
  'client.kpi.invoicesSub': '{{count}} ausstehend',
  'client.kpi.overdueSubOk': 'Alle Rechnungen im Zeitplan',
  'client.kpi.overdueSubAction': 'Handlung erforderlich',
  'client.kpi.renewalValueDays': '{{count}} Tage',
  'client.kpi.renewalDue': 'Fällig: {{date}}',
  'client.kpi.renewalSubNone': 'Keine Verlängerung hinterlegt',
  'client.calls.title': 'Eingegangene Anrufe',
  'client.calls.caller': 'Anrufer',
  'client.calls.phone': 'Telefon',
  'client.calls.date': 'Datum & Uhrzeit',
  'client.calls.duration': 'Dauer',
  'client.calls.notes': 'Notizen',
  'client.calls.noCalls': 'Keine eingegangenen Anrufe',
  'client.calls.minutes': 'Min',
  'client.calls.reason': 'Grund',
  'client.calls.priorityLow': 'Niedrige Priorität',
  'client.calls.priorityMedium': 'Mittlere Priorität',
  'client.calls.priorityHigh': 'Hohe Priorität',
  'client.calls.openRecording': 'Aufzeichnung anhören',
  'client.calls.openRecordingFailed': 'Aufzeichnung konnte nicht geöffnet werden',
  'client.task.button': 'Anfrage an Buchhalter senden',
  'client.task.title': 'Neue Anfrage für Buchhalter',
  'client.task.subtitle': 'Beschreiben Sie Ihr Anliegen. Die Referenzpreisliste können Sie bei Bedarf öffnen.',
  'client.task.taskTitle': 'Anfragetitel',
  'client.task.taskDesc': 'Anfragebeschreibung',
  'client.task.send': 'Anfrage senden',
  'client.task.sending': 'Senden...',
  'client.task.sent': 'Anfrage gesendet!',
  'client.task.failed': 'Fehler beim Senden der Anfrage',
  'client.task.fillRequired': 'Anfragetitel ist erforderlich',
  'client.task.pricing': 'Preisliste',
  'client.task.pricingInfo': 'Preisinformationen',
  'client.task.selectServiceLabel': 'Leistung aus der Preisliste',
  'client.task.selectServicePlaceholder': 'Leistung wählen (füllt Titel und Beschreibung)',
  'client.task.lblCategory': 'Kategorie',
  'client.task.lblService': 'Leistung',
  'client.task.lblPriceRsd': 'Preis (Kunden, RSD)',
  'client.task.lblUnit': 'Einheit',
  'client.task.autoDescFooter': 'Ergänzen Sie Frist, Sonderwünsche oder Fragen unten.',
  'client.task.fullPricingOnSite': 'Vollständige Preisliste auf der Website',
  'client.support.title': 'Support kontaktieren',
  'client.support.subtitle': 'Beschreiben Sie Ihr Anliegen. Wir melden uns schnellstmöglich.',
  'client.support.fieldTitle': 'Titel',
  'client.support.fieldMessage': 'Nachricht',
  'client.support.urgency': 'Dringlichkeit',
  'client.support.urgencyLow': 'Niedrig',
  'client.support.urgencyMedium': 'Mittel',
  'client.support.urgencyHigh': 'Hoch',
  'client.support.contactPref': 'Wie sollen wir Sie kontaktieren?',
  'client.support.contactEmail': 'E-Mail',
  'client.support.contactPhone': 'Telefon',
  'client.support.contactBoth': 'E-Mail oder Telefon',
  'client.support.send': 'Senden',
  'client.support.sending': 'Wird gesendet...',
  'client.support.sent': 'Ihre Nachricht wurde gesendet.',
  'client.support.failed': 'Senden fehlgeschlagen. Bitte erneut versuchen.',
  'client.support.fillTitle': 'Titel ist erforderlich.',
  'client.support.fillMessage': 'Nachricht ist erforderlich.',
  'client.taskRequests.title': 'Anfragen',
  'client.taskRequests.loading': 'Anfragen werden geladen...',
  'client.taskRequests.noTasks': 'Noch keine Anfragen eingereicht',
  'client.taskRequests.pending': 'Ausstehend',
  'client.taskRequests.submitted': 'Eingereicht',
  'client.taskRequests.createdAt': 'Erstellt',
  'client.taskRequests.submittedAt': 'An den Buchhalter weitergeleitet',
  'client.taskRequests.openTicket': 'Ticket öffnen',
  'client.taskRequests.waitingForTicket': 'Warten auf den Ticket-Link vom Admin',
  'client.taskRequests.targetAccountant': 'Buchhaltung',
  'client.taskRequests.targetSupport': 'Support',
  'client.taskRequests.urgency': 'Dringlichkeit',
  'client.taskRequests.contactPref': 'Kontakt',
  'client.taskRequests.tabAccountant': 'Buchhaltung',
  'client.taskRequests.tabSupport': 'Support',
  'client.taskRequests.emptyAccountant': 'Noch keine Buchhaltungsanfragen.',
  'client.taskRequests.emptySupport': 'Noch keine Support-Anfragen.',
  'client.taskRequests.supportStatusReceived': 'Eingegangen',
  'client.taskRequests.supportStatusInProgress': 'In Bearbeitung',
  'client.taskRequests.supportStatusCompleted': 'Erledigt',
  'client.taskRequests.updatedAt': 'Aktualisiert',
  'login.title': 'Anmelden',
  'login.subtitle': 'Kundenportal',
  'login.desc': 'Geben Sie Ihre Zugangsdaten ein',
  'login.email': 'E-Mail-Adresse',
  'login.password': 'Passwort',
  'login.signIn': 'Anmelden',
  'login.signingIn': 'Anmeldung...',
  'login.fillRequired': 'Bitte E-Mail und Passwort eingeben',
  'login.invalidCredentials': 'Ungültige E-Mail oder Passwort',
  'login.forgotPassword': 'Passwort vergessen',
  'login.forgotTitle': 'Passwort zurücksetzen',
  'login.forgotDesc': 'Geben Sie Ihre E-Mail-Adresse ein. Wir senden Ihnen einen Link zum Festlegen eines neuen Passworts.',
  'login.sendResetLink': 'Link senden',
  'login.sendingReset': 'Wird gesendet…',
  'login.resetSent': 'Falls ein Konto existiert, erhalten Sie eine E-Mail mit weiteren Schritten.',
  'login.resetEmailRequired': 'Bitte E-Mail-Adresse eingeben.',
  'login.resetFailed': 'E-Mail konnte nicht gesendet werden. Bitte erneut versuchen.',
  'login.backToSignIn': 'Zurück zur Anmeldung',
  'login.resetLoading': 'Laden…',
  'login.resetPasswordTitle': 'Neues Passwort',
  'login.resetPasswordDesc': 'Geben Sie ein neues Passwort für Ihr Konto ein.',
  'login.newPassword': 'Neues Passwort',
  'login.confirmPassword': 'Passwort bestätigen',
  'login.passwordMismatch': 'Passwörter stimmen nicht überein.',
  'login.passwordTooShort': 'Passwort muss mindestens 6 Zeichen haben.',
  'login.saveNewPassword': 'Passwort speichern',
  'login.savingPassword': 'Speichern…',
  'login.passwordUpdated': 'Passwort wurde aktualisiert.',
  'login.redirectingToLogin': 'Weiterleitung zur Anmeldung…',
  'login.resetInvalid': 'Dieser Link ist ungültig oder abgelaufen. Fordern Sie einen neuen auf der Anmeldeseite an.',
  'admin.companies.addNew': 'Neues Unternehmen hinzufügen',
  'admin.companies.save': 'Unternehmen speichern',
  'admin.companies.saveChanges': 'Änderungen speichern',
  'admin.companies.edit': 'Unternehmen bearbeiten',
  'admin.companies.editTitle': 'Unternehmen bearbeiten',
  'admin.companies.editDrawerHint': 'Felder unten anpassen und speichern.',
  'admin.companies.view': 'Ansehen',
  'admin.companies.delete': 'Löschen',
  'admin.companies.edit2': 'Bearbeiten',
  'admin.companies.noMatch': 'Keine Unternehmen gefunden',
  'admin.companies.loading': 'Unternehmen werden geladen...',
  'admin.companies.taxLabel': 'Steuer',
  'admin.companies.colName': 'Unternehmen',
  'admin.companies.colCountry': 'Land',
  'admin.companies.colPlan': 'Tarif',
  'admin.companies.colStatus': 'Status',
  'admin.companies.detailBadge': 'Unternehmen',
  'admin.companies.sectionInfo': 'Unternehmensdaten',
  'admin.companies.sectionDocuments': 'Dokumente',
  'admin.companies.sectionFinance': 'Finanzen & Rechnungen',
  'admin.companies.financeTotalPaid': 'Insgesamt bezahlt (gesamt)',
  'admin.companies.financePaidCount': 'Bezahlte Rechnungen',
  'admin.companies.financePending': 'Ausstehend',
  'admin.companies.financeOverdue': 'Überfällig',
  'admin.companies.detailNoDocuments': 'Noch keine Dokumente für dieses Unternehmen.',
  'admin.companies.recentInvoices': 'Letzte Rechnungen',
  'admin.companies.openDoc': 'Öffnen',
  'admin.companies.detailLoading': 'Laden…',
  'admin.companies.serviceStart': 'Servicebeginn',
  'admin.companies.nextRenewal': 'Nächste Verlängerung',
  'admin.companies.searchPlaceholder': 'Unternehmen suchen...',
  'admin.companies.countOf': 'von',
  'admin.companies.companiesWord': 'Unternehmen',
  'admin.companies.addShort': 'Hinzufügen',
  'admin.companies.refreshTitle': 'Aktualisieren',
  'admin.companies.filterAll': 'Alle',
  'admin.companies.statusActive': 'Aktiv',
  'admin.companies.statusPending': 'Ausstehend',
  'admin.companies.statusSuspended': 'Gesperrt',
  'admin.companies.statusArchived': 'Archiviert',
  'admin.revenue.title': 'Monatlicher Umsatz',
  'admin.revenue.subtitle': 'Letzte 12 Monate · bezahlte Rechnungen',
  'admin.revenue.totalLabel': 'Gesamt (12 M.):',
  'admin.revenue.invoices': 'Rechnungen',
  'admin.quick.title': 'Schnellaktionen',
  'admin.quick.uploadDoc': 'Dokument hochladen',
  'admin.quick.uploadDocDesc': 'Dokument zu Unternehmen hinzufügen',
  'admin.quick.addCompany': 'Unternehmen hinzufügen',
  'admin.quick.addCompanyDesc': 'Neuen Kunden registrieren',
  'admin.quick.issueInvoice': 'Rechnung ausstellen',
  'admin.quick.issueInvoiceDesc': 'Neue Rechnung erstellen',
  'admin.quick.addUser': 'Benutzer hinzufügen',
  'admin.quick.addUserDesc': 'Portalzugang zuweisen',
  'admin.quick.addCall': 'Anruf erfassen',
  'admin.quick.addCallDesc': 'Eingehenden Anruf protokollieren',
  'admin.quick.generateReport': 'Bericht erstellen',
  'admin.quick.generateReportDesc': 'Unternehmensbericht exportieren',
  'admin.quick.portalSettings': 'Portaleinstellungen',
  'admin.quick.portalSettingsDesc': 'Portalkonfiguration verwalten',
  'admin.quick.pendingTasks': 'Ausstehende Aufgaben',
  'admin.quick.noTasks': 'Keine ausstehenden Aufgaben',
  'admin.quick.portalHealth': 'Portalzustand',
  'admin.quick.docCoverage': 'Dokumentenabdeckung',
  'admin.quick.collectionRate': 'Rechnungseinzugsrate',
  'admin.quick.activeCompanies': 'Aktive Unternehmen',
  'admin.activity.title': 'Letzte Aktivitäten',
  'admin.activity.subtitle': 'Live-Aktivitätsfeed des Portals',
  'admin.activity.viewAll': 'Vollständiges Aktivitätsprotokoll anzeigen',
  'admin.activity.noActivity': 'Keine aktuellen Aktivitäten',
  'admin.activity.docUploaded': 'Dokument hochgeladen für',
  'admin.activity.invoiceOverdue': 'Rechnung überfällig -',
  'admin.activity.paymentReceived': 'Zahlung eingegangen -',
  'admin.activity.invoiceIssued': 'Rechnung ausgestellt -',
  'admin.activity.newPending': 'Neues Unternehmen wartet auf Genehmigung',
  'admin.activity.newOnboarded': 'Neues Unternehmen registriert',
  'admin.activity.contactForm': 'Neue Nachricht aus dem Kontaktformular',
  'admin.kpi.activeCompanies': 'Aktive Unternehmen',
  'admin.kpi.currentlyActive': 'Derzeit aktiv',
  'admin.kpi.pendingDocs': 'Ausstehende Dokumente',
  'admin.kpi.awaitingUpload': 'Warten auf Upload',
  'admin.kpi.outstandingInvoices': 'Offene Rechnungen',
  'admin.kpi.pendingPayment': 'Zahlung ausstehend',
  'admin.kpi.overdueInvoices': 'Überfällige Rechnungen',
  'admin.kpi.actionRequired': 'Aktion erforderlich',
  'admin.kpi.revenue': 'Umsatz -',
  'admin.kpi.paidThisMonth': 'Bezahlte Rechnungen diesen Monat',
  'admin.kpi.newCompanies': 'Neue Unternehmen (30T)',
  'admin.kpi.onboardedThisMonth': 'Diesen Monat registriert',
  'admin.kpi.urgent': 'DRINGEND',
  'admin.kpi.contactForm': 'Kontaktformular',
  'admin.kpi.contactFormSub': 'Anfragen gesamt',
  'admin.kpi.contactFormUnread': 'Ungelesene Anfragen',
  'admin.kpi.contactFormUnreadSub': 'Noch nicht geöffnet',
  'client.notif.document': 'Neues Dokument:',
  'client.notif.invoiceIssued': 'Rechnung:',
  'client.notif.invoicePaid': 'Bezahlte Rechnung:',
  'client.notif.task': 'Anfrage',
  'client.notif.call': 'Anruf',
  'client.invoices.loading': 'Rechnungen werden geladen...',
  'client.invoices.noInvoices': 'Keine Rechnungen gefunden',
  'client.invoices.pending': 'Zahlung ausstehend',
  'client.invoices.viewAll': 'Alle anzeigen',
  'client.invoices.colInvoice': 'Rechnung',
  'client.invoices.colDesc': 'Beschreibung',
  'client.invoices.colIssued': 'Ausgestellt',
  'client.invoices.colDue': 'Fälligkeitsdatum',
  'client.invoices.colAmount': 'Betrag',
  'client.invoices.colStatus': 'Status',
  'client.invoices.view': 'Rechnung ansehen',
  'client.invoices.downloadAttachment': 'Angehängte Datei herunterladen',
  'client.invoices.openAttachment': 'Angehängte Datei öffnen',
  'client.invoices.noAttachment': 'Zu dieser Rechnung liegt keine Datei vor.',
  'client.invoices.openFailed': 'Datei konnte nicht geöffnet werden.',
  'client.invoices.downloadedOk': 'Datei für Rechnung {{n}} geöffnet',
  'portal.languageHint': 'Sprache im oberen Menü ändern',
  'portal.emailLanguage': 'Sprache für E-Mail-Benachrichtigungen',
  'portal.emailLanguageHint':
    'Transaktions-E-Mails aus dem Portal (Rechnungen, Teamdokumente, Anrufe, Mahnungen) verwenden diese Sprache.',
  'portal.emailLanguageSaved': 'E-Mail-Sprache gespeichert.',

  // VirtualOfficeSection
  'vo.sectionTitle': 'Eine serbische Geschäftsadresse,\nohne Bürokosten',
  'vo.sectionDesc': 'Etablieren Sie eine glaubwürdige, rechtlich registrierte serbische Geschäftspräsenz vom ersten Tag an - ohne die Kosten und Verpflichtungen eines physischen Büros.',
  'vo.benefit1.title': 'Erstklassige Belgrader Adresse',
  'vo.benefit1.desc': 'Topčiderska Straße, Gemeinde Savski venac - Geschäftszone im geschützten Grüngürtel, nahe dem Zentrum von Belgrad.',
  'vo.benefit2.title': 'Postbearbeitung & Weiterleitung',
  'vo.benefit2.desc': 'Wir empfangen, scannen und leiten Ihre Geschäftskorrespondenz weiter, wohin Sie möchten.',
  'vo.benefit3.title': 'Registrierungsunterstützung',
  'vo.benefit3.desc': 'Wir helfen bei der APR-Unternehmensregistrierung und stellen die erforderliche Adressdokumentation bereit.',
  'vo.benefit4.title': 'Für ausländische Unternehmen',
  'vo.benefit4.desc': 'Ideal für internationale Unternehmen, die eine rechtliche serbische Präsenz ohne physischen Umzug benötigen.',
  'vo.benefit5.title': 'Rechtlich konform',
  'vo.benefit5.desc': 'Vollständig konform mit serbischem Handelsrecht und APR-Registrierungsanforderungen.',
  'vo.benefit6.title': 'Aktiv innerhalb von 48h',
  'vo.benefit6.desc': 'Ihre Adresse und der Portalzugang sind innerhalb von zwei Werktagen nach Unterzeichnung bereit.',
  'vo.legalHighlight':
    'Als Einzige in Serbien bieten wir ein zu 100 % legales virtuelles Büro, vollständig nach allen Gesetzen der Republik Serbien.',
  'vo.whoFor': 'Für wen ist es',
  'vo.whoFor1': 'Ausländische Unternehmen, die den serbischen Markt erschließen',
  'vo.whoFor2': 'E-Commerce-Unternehmen, die eine serbische MwSt-Adresse benötigen',
  'vo.whoFor3': 'Freiberufler und Berater, die eine professionelle Geschäftsadresse benötigen',
  'vo.whoFor4': 'Unternehmen, die physischen Büroraum reduzieren',
  'vo.whoFor5': 'Startups, die vor der Einstellung eine registrierte Adresse benötigen',
  'vo.plansTitle': 'Virtuelles-Büro-Paket',
  'vo.plansDesc':
    'Ein Paket umfasst alle unten genannten Leistungen. Adresse und Finanzamt wählen Sie nach geschäftlichen und steuerlichen Prioritäten.',
  'vo.requestQuote': 'Angebot anfordern',
  'vo.pack.title': 'Virtuelles Büro',
  'vo.pack.tagline': 'Ein Preis, ein Paket - Adresse, Post und Portal.',
  'vo.pack.priceRsd': '3.500 RSD',
  'vo.pack.priceEur': '~30 EUR',
  'vo.pack.annualNote': '2 Monate gratis bei jährlicher Zahlung',
  'vo.pack.f1': 'Geschäftsadresse in Belgrad oder Kovin (Finanzamt Pančevo); Loznica folgt bald, Interesse bekunden',
  'vo.pack.f2': 'E-Mail-Benachrichtigung bei eingehender Post',
  'vo.pack.f3':
    'Eingehende Post wird gescannt, per E-Mail versendet und ins Kundenportal hochgeladen',
  'vo.pack.f4': 'Posteingang in ein gemeinsames Postfach',
  'vo.pack.f5': 'Separater Ordner für Ihre Dokumentation',
  'vo.pack.f6': 'Rabatte auf Coworking und Besprechungsräume',
  'vo.pack.f7': 'Zugang zum digitalen Portal zur Nachverfolgung Ihrer Dokumentation',

  'vo.addOns.tag': 'ZUSATZLEISTUNGEN',
  'vo.addOns.title': 'Zusatzleistungen zum virtuellen Büro',
  'vo.addOns.subtitle': 'Erweitern Sie Ihr Paket nach Bedarf – klare Leistungen und Festpreise, wo möglich.',
  'vo.addOns.1.title': 'Telefonzentrale / Anrufannahme',
  'vo.addOns.1.desc':
    'Wir nehmen Anrufe für Sie entgegen. Unsere Nummer kann beim APR hinterlegt werden; wir bearbeiten alle Anrufe und informieren Sie über den Anrufer.',
  'vo.addOns.1.price': '+500 RSD / Monat',
  'vo.addOns.2.title': 'Dokumentenprüfung & Steuerberatung',
  'vo.addOns.2.desc': 'Unser Anwaltsteam erklärt alle Dokumenttypen zu Sonderkonditionen.',
  'vo.addOns.2.price': 'Nach Vereinbarung',
  'vo.addOns.3.title': 'Einreichung der Umweltgebühr (EKO)',
  'vo.addOns.3.desc':
    'Service-Einreichung der EKO-Gebühr in den Gemeinden, in denen wir tätig sind.',
  'vo.addOns.3.price': '3.000 RSD / Antrag',
  'vo.addOns.4.title': 'Eigenes Postfach & Namensschild',
  'vo.addOns.4.desc': 'Eigenes Postfach und Schild am Kasten. Maße 370 × 250 × 90 mm.',
  'vo.addOns.4.price': '+1.000 RSD / Monat',
  'vo.addOns.5.title': 'Besprechungsraum',
  'vo.addOns.5.desc': 'Reservieren Sie einen Besprechungsraum in unseren Räumen zu Aktionspreisen.',
  'vo.addOns.5.price': 'Nach Vereinbarung',
  'vo.addOns.6.title': 'Physische Postweiterleitung',
  'vo.addOns.6.desc':
    'Ein Schreiben oder mehrere Sendungen – Versand per Eil- oder Einschreiben auf Ihre Anweisung.',
  'vo.addOns.6.price': '+500 RSD + Porto (PTT)',

  'vo.extraBenefits.tag': 'VIRTUELLES BÜRO',
  'vo.extraBenefits.title': 'Vorteile des virtuellen Büros',
  'vo.extraBenefits.desc': 'Zusätzliche Vorteile Ihres Unternehmens mit einer eingetragenen Geschäftsadresse.',
  'vo.extraBenefits.1.title': 'Schutz der Geschäftsadresse',
  'vo.extraBenefits.1.desc':
    'Ihre eingetragene Adresse bleibt stabil und klar im APR-Register sichtbar, mit professioneller Postbearbeitung zum Schutz vor Missbrauch.',
  'vo.extraBenefits.2.title': 'Schutz der Telefonnummer',
  'vo.extraBenefits.2.desc':
    'Geschäftskontakt kann über unsere Adresse geführt werden, damit private Nummern und persönliche Daten vom öffentlichen Profil getrennt bleiben.',
  'vo.extraBenefits.3.title': 'Eine der günstigeren Steuerzonen Belgrads',
  'vo.extraBenefits.3.desc':
    'Standort in einer der im Stadtvergleich günstigeren Zonen, was die Gesamtbetriebs- und Steuerlast positiv beeinflussen kann.',
  'vo.extraBenefits.4.title': 'Briefkasten und Namensschild immer vor Ort',
  'vo.extraBenefits.4.desc':
    'Physisches Postfach und Firmenschild sind stets vor Ort, um Postrückläufer zu vermeiden und Anforderungen von Prüfungen zu erfüllen, die Beschilderung und Posteingang an der Adresse vorschreiben.',
  'vo.extraBenefits.5.title': 'Postarchivierung und Hauptbuch',
  'vo.extraBenefits.5.desc':
    'Eingehende Post wird regelkonform erfasst und archiviert, mit sicherer Aufbewahrung für die Führung des Archivbuchs.',
  'vo.extraBenefits.6.title': 'Empfang des Steuerprüfers',
  'vo.extraBenefits.6.desc':
    'Eine bevollmächtigte Person ist jederzeit anwesend, um den Steuerprüfer zu empfangen und die nötigen Unterlagen vor Ort bereitzustellen.',

  'pausalBanner.text':
    'Unser Büro liegt in einer geschützten Grünzone, Gemeinde Savski venac. Zusätzlich bieten wir eine registrierte Adresse in Kovin (Finanzamt Pančevo). Standort Loznica kommt bald; bei Interesse bitte Kontakt aufnehmen.',
  'pausalBanner.button': 'Pauschalsteuer-Rechner',
  'pausalBanner.textInlineLink':
    'Prüfen Sie auf dieser Seite, ob Ihre Tätigkeit pauschal besteuert werden kann.',
  'pausalBanner.aria': 'Pauschalsteuer – Link zum Rechner der Steuerbehörde',

  // CoworkingSection
  'cw.sectionTitle': 'Ein professioneller Arbeitsraum\nim Herzen von Belgrad',
  'cw.sectionDesc': 'Für Produktivität und Zusammenarbeit konzipiert. Arbeiten Sie mit anderen Fachleuten in einer sauberen, ruhigen, geschäftsorientierten Umgebung.',
  'cw.amenity1': 'Gigabit-Internet',
  'cw.amenity1.desc': '1 Gbit/s Glasfaser',
  'cw.amenity2': 'Kaffee & Küche',
  'cw.amenity2.desc': 'Voll ausgestattet',
  'cw.amenity3': 'Dual-Monitor-Setup',
  'cw.amenity3.desc': 'Auf Anfrage',
  'cw.amenity4': 'Besprechungsräume',
  'cw.amenity4.desc': '3 verfügbar',
  'cw.amenity5': 'Flexible Buchung',
  'cw.amenity5.desc': 'Tag oder Monat',
  'cw.amenity6': '24h Sicherer Zugang',
  'cw.amenity6.desc': 'Kartenzugang',
  'cw.plan.hotDesk.desc': 'Flexibler offener Schreibtisch, an jedem Werktag verfügbar. Perfekt für Freiberufler.',
  'cw.plan.hotDesk.f1': 'Beliebiger verfügbarer Schreibtisch',
  'cw.plan.hotDesk.f2': 'Werktäglicher Zugang',
  'cw.plan.hotDesk.f3': 'Schließfachspeicherung',
  'cw.plan.hotDesk.f4': 'Besprechungsraumguthaben (2h/Mo)',
  'cw.plan.dedicated.desc': 'Ihr eigener reservierter Schreibtisch, abschließbarer Stauraum und ein fester Arbeitsplatz.',
  'cw.plan.dedicated.f1': 'Reservierter Schreibtisch 24/7',
  'cw.plan.dedicated.f2': 'Abschließbares Schließfach',
  'cw.plan.dedicated.f3': 'Geschäftsadress-Zusatz verfügbar',
  'cw.plan.dedicated.f4': 'Besprechungsraumguthaben (5h/Mo)',
  'cw.plan.private.desc': 'Vollständig geschlossenes Privatbüro für 1–4 Personen. Inklusive abschließbarem Stauraum und Besprechungsraumstunden.',
  'cw.plan.private.f1': 'Geschlossenes Privatbüro',
  'cw.plan.private.f2': 'Bis zu 4 Arbeitsplätze',
  'cw.plan.private.f3': 'Besprechungsraum (10h/Mo)',
  'cw.plan.private.f4': 'Individuelles Branding an der Tür',

  // AccountingSection
  'acc.sectionTitle': 'Professionelle Geschäftsunterstützung\nfür Serbien',
  'acc.sectionDesc': 'Eine versäumte Frist bei der Steuerverwaltung, eine fehlerhafte USt-Meldung oder eine nicht konforme Adresse können Bußgelder und Betriebsstörungen bedeuten - besonders wenn Sie kein Serbisch sprechen und die APR-Vorschriften nicht kennen. Unser Team arbeitet in fünf Sprachen, übernimmt diese Komplexität und überwacht die Fristen für Sie, damit Sie sich auf Ihr Geschäft konzentrieren können.',
  'acc.svc1.title': 'Buchhaltung & Rechnungswesen',
  'acc.svc1.desc': 'Monatliche Buchhaltung, Erstellung von Jahresabschlüssen und Compliance-Berichterstattung gemäß serbischen Rechnungslegungsstandards (MSFI/MRS).',
  'acc.svc1.tag1': 'Monatliche Berichte',
  'acc.svc1.tag2': 'MSFI/MRS konform',
  'acc.svc2.title': 'Steuer- & MwSt-Registrierung',
  'acc.svc2.desc': 'MwSt-Registrierung, vierteljährliche MwSt-Erklärungen, Körperschaftsteuererklärung und alle gesetzlichen Fristen beim Finanzamt.',
  'acc.svc2.tag1': 'MwSt-Registrierung',
  'acc.svc2.tag2': 'Vierteljährliche Erklärungen',
  'acc.svc3.title': 'Rechtliche Dokumentenunterstützung',
  'acc.svc3.desc': 'Vorbereitung und Prüfung von Verträgen, Arbeitsverträgen und Geschäftsdokumenten gemäß serbischem Handels- und Arbeitsrecht.',
  'acc.svc3.tag1': 'Vertragserstellung',
  'acc.svc3.tag2': 'Arbeitsrecht',
  'acc.svc4.title': 'Mehrsprachige Beratung',
  'acc.svc4.desc': 'Unser Team bietet Beratungen auf Serbisch, Englisch, Russisch, Türkisch und Deutsch an.',
  'acc.svc4.tag1': '5 Sprachen',
  'acc.svc4.tag2': 'Internationale Kunden',
  'acc.stat1.label': 'Jahre Erfahrung',
  'acc.stat1.sub': 'im serbischen Wirtschaftsrecht',
  'acc.stat2.label': 'Betreute Kunden',
  'acc.stat2.sub': 'lokal und international',
  'acc.stat3.label': 'Sprachen',
  'acc.stat3.sub': 'Beratungssprachen',
  'acc.stat4.label': 'Steuererklärungen',
  'acc.stat4.sub': 'seit 2014',
  'acc.cta.title': 'Kostenlose Beratung buchen',
  'acc.cta.desc': 'Sprechen Sie mit einem unserer Buchhaltungs- oder Rechtsberater über Ihre spezifische Geschäftssituation. Verfügbar auf Serbisch, Englisch, Russisch, Türkisch und Deutsch.',
  'acc.cta.btn': 'Gespräch vereinbaren',
  'acc.pricing.show': 'Preisliste anzeigen',
  'acc.pricing.hide': 'Preisliste ausblenden',
  'acc.pricing.footer': 'Alle Preise in serbischen Dinar (RSD). Mindestpreise, verhandelbar. ✓ kennzeichnet Leistungen, die vollständig online erbracht werden können.',

  // TrustSection
  'trust.statsTitle': 'Vertrauen von Unternehmen aus aller Welt',
  'trust.stat1': 'Registrierte Unternehmen',
  'trust.stat2': 'Verwaltete Dokumente',
  'trust.stat3': 'Jahre im Geschäft',
  'trust.stat4': 'Bediente Länder',
  'trust.trustedBy': 'Vertrauen von Unternehmen aus Europa und darüber hinaus',
  'trust.testimonialsTag': 'Kundenstimmen',
  'trust.testimonialsTitle': 'Was unsere Kunden sagen',
  'trust.test1.text':
    'Wir brauchten eine serbische Geschäftsadresse für unsere EU-Expansion. Top14 Bürolösungen haben alles abgedeckt: Registrierung, Dokumente und Postweiterleitung. Das Kundenportal macht alles unglaublich einfach.',
  'trust.test1.highlight': 'In unter 48 Stunden registriert',
  'trust.test2.text':
    'Als russische Unternehmerin brauchte ich einen vertrauenswürdigen Partner in Serbien. Top14 bot mehrsprachigen Support; MwSt-Registrierung und Ablauf liefen reibungslos.',
  'trust.test2.highlight': 'Mehrsprachiger Support machte den Unterschied',
  'trust.test3.text':
    'Der Coworking-Space ist professionell und gut ausgestattet. Top14 Bürolösungen sind meine Basis in Belgrad, wenn ich in Serbien bin: tolles Internet, ruhige Atmosphäre und ein hilfsbereites Team.',
  'trust.test3.highlight': 'Mein bevorzugter Belgrader Arbeitsplatz',

  'partners.tag': 'Partner',
  'partners.title': 'Unsere Partner',
  'partners.desc':
    'Teams, die das Top14‑Ökosystem ergänzen: digitale Präsenz, Finanzen, KI und Bildung.',
  'partners.evi.name': 'EVI Solutions',
  'partners.evi.desc':
    'Eine starke Website ist oft der erste Schritt zu glaubwürdigem Auftritt. Darüber hinaus entwickelt EVI komplette Portale, E‑Commerce und Apps, plus professionelles IT‑Betriebsmanagement, damit Ihre digitale Schicht beim Wachsen stabil bleibt.',
  'partners.tim011.name': 'Tim011 Digital',
  'partners.tim011.desc':
    'Partner für den schnellen Start von Einzelunternehmen oder Gesellschaften, mit Fokus auf Tempo und digitale Buchhaltung. Verlässliche Unterstützung im Tagesgeschäft und klarere Steuerpositionierung: Sie führen das Geschäft, nicht den Papierkram.',
  'partners.intrascope.name': 'Intrascope',
  'partners.intrascope.desc':
    'Eine KI‑Infrastruktur fürs Team: führende Modelle an einem Ort, gemeinsamer Kontext und Kontrolle im Unternehmen. Mit dem Promo‑Code TOP150 erhalten Sie 150 USD Rabatt auf den ersten Kauf des Jahresplans.',
  'partners.capitaale.name': 'Capitaale',
  'partners.capitaale.desc':
    'Capitaale ist eine App für Unternehmer, die im Ausland abrechnen. Echter RSD-Saldo nach Bankkurs, Live-Pauschallimit, Warnung wenn ein Kunde über 70 % des Umsatzes ausmacht, und Rechnung in EUR oder USD in 60 Sekunden. Die ersten 7 Tage kostenlos.',

  // Footer hardcoded items
  'footer.businessAddress': 'Geschäftsadresse',
  'footer.legalAssistance': 'Rechtliche Unterstützung',
  'footer.companyRegistration': 'Unternehmensregistrierung',

  // Blog
  'blog.subtitle': 'Leitfäden zu virtuellem Büro, Firmengründung und Geschäftsadresse in Belgrad und Serbien.',
  'blog.readMore': 'Weiterlesen',
  'blog.backToBlog': 'Zurück zum Blog',
  'blog.related': 'Verwandte Artikel',
  'blog.published': 'Veröffentlicht',
  'blog.minRead': 'Min. Lesezeit',
  'blog.ctaTitle': 'Bereit für ein virtuelles Büro in Belgrad?',
  'blog.ctaDesc': 'Vereinbaren Sie eine Beratung und erfahren Sie, wie Top14 Ihr Geschäft in Serbien unterstützt.',
  'blog.ctaBtn': 'Kontakt',
  'blog.authorTeam': 'Top14 Team',
  'blog.sources': 'Nützliche Links',
  'blog.breadcrumbHome': 'Startseite',
};

export default de;
